import { Component, inject } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { I18nService } from '../../../../../core/services/i18n.service';
import { SpsLeadFormComponent } from '../../../../../custom/components/sps-lead-form/sps-lead-form.component';

@Component({
  selector: 'db-add-business-partner',
  imports: [
    Card,
    Button,
    PrimeTemplate,
    SpsLeadFormComponent
  ],
  templateUrl: './db-add-business-partner.component.html'
})
export class DbAddBusinessPartnerComponent {

  i18n = inject(I18nService);

  /**
   * Lead-Form Dialog
   */
  showAddLeadDialog: boolean = false;

  addBusinessPartner() {
    this.showAddLeadDialog = true;
  }

  protected leadFormClosed() {
    this.showAddLeadDialog = false;
  }

}
